var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showRenewButton)?_c('router-link',{staticClass:"renewButton btn btn-primary btn-small",attrs:{"to":{name: 'accountMembershipRenewal'}}},[_vm._v("\n  Renew\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }